/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';
import { Flexed } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from './Portfolio.styled';

import moment from 'moment';
import {
  formatUSDNoDecimals,
  isBeforeAugustFirst2025,
  USDT
} from '../../helpers/helperFunctions';
import { Responsive } from '../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { UserPackage } from './Portfolio.types';

export const PortfolioTravelItem = ({ item }: { item: UserPackage }) => {
  const { t } = useTranslation('my_hubs');
  return (
    <>
      <BoxBig relative>
        <HubImage image={item.image}>
          <H4 color={color.colors.neutral0}>{item?.name}</H4>
        </HubImage>
        <div>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <Tr style={{ cursor: 'pointer' }}>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('price')}
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {isBeforeAugustFirst2025(item?.dateOfCreation)
                    ? item.price * 0.9
                    : item.price}
                  <P3 mb='3'>{USDT}</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('date_of_purchase')}
                </CaptionText>
                <P1 bold>
                  {moment(item?.dateOfPurchase).format('DD MMM YYYY')}
                </P1>
              </Td>
            </Tr>
          </div>
          <Flexed column gap='30px'>
            <Responsive style={{ margin: '24px 0' }} between>
              <Flexed mbSM='20' rowSM>
                <P3 caps bold color={color.colors.secondary100} mr='60'>
                  TRAVELUTION MEMBERSHIP DETAILS
                </P3>
                <P3 flex color={color.colors.secondary100} mr='60'>
                  {t('order_id')}:{' '}
                  <P3 bold ml='2' color={color.colors.secondary100}>
                    {item?.id}
                  </P3>
                </P3>
                <P3 flex color={color.colors.secondary100}>
                  Package ID:
                  <P3 bold ml='2' color={color.colors.secondary100}>
                    {item?.packageId}
                  </P3>
                </P3>
              </Flexed>
            </Responsive>
          </Flexed>
        </div>
      </BoxBig>
    </>
  );
};
